const STORAGE_KEY = "uhd-color-scheme";
const PREFERENCES = ["system", "dark", "light"];
const LABELS = {
  system: "Appearance: System",
  dark: "Appearance: Dark",
  light: "Appearance: Light",
};

function storedPreference() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === "dark" || value === "light") return value;
  } catch (_error) {
    // private mode / blocked storage
  }
  return "system";
}

function resolvedScheme(preference = storedPreference()) {
  if (preference === "dark" || preference === "light") return preference;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function applyColorScheme() {
  const preference = storedPreference();
  const scheme = resolvedScheme(preference);
  document.documentElement.setAttribute("data-color-scheme", scheme);
  document.querySelectorAll("[data-color-scheme-label]").forEach((el) => {
    el.textContent = LABELS[preference];
  });
  document.documentElement.dispatchEvent(
    new CustomEvent("uhd:color-scheme-change", { detail: { scheme, preference } })
  );
}

function cycleColorScheme(event) {
  event.preventDefault();
  const next = PREFERENCES[(PREFERENCES.indexOf(storedPreference()) + 1) % PREFERENCES.length];
  try {
    if (next === "system") localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, next);
  } catch (_error) {
    // ignore persistence failures; still apply for this session
  }
  applyColorScheme();
}

document.addEventListener("click", (event) => {
  const toggle = event.target.closest("[data-color-scheme-toggle]");
  if (!toggle) return;
  cycleColorScheme(event);
});

document.addEventListener("turbo:load", applyColorScheme);
applyColorScheme();

const media = window.matchMedia("(prefers-color-scheme: dark)");
if (typeof media.addEventListener === "function") {
  media.addEventListener("change", () => {
    if (storedPreference() === "system") applyColorScheme();
  });
}
